import React from "react";
import { ConfirmationContent } from "../styles";
import {
  ContentMessage,
  Types,
} from "../../../../../CommonComponents/ContentMessages";
export const ConfirmTerms = () => (
  <>
    <ConfirmationContent>
      <ContentMessage
        type={[Types.GET_CONFIRMATION_MESSAGE]}
        page={"Grant Agreement Confirmation"}
        html={true}
        property="field_success_message"
        defaultMessage={""}
      />
    </ConfirmationContent>
  </>
);
